import { defineMessages } from 'react-intl';

const scope = 'conversation_panel_reply';

export default defineMessages({
  roleChatbot: {
    id: `${scope}.role_chatbot`,
    defaultMessage: 'Chat assistant',
  },
  saidAtTime: {
    id: `${scope}.said_at_time`,
    defaultMessage: 'said at {time}',
  },
});
